import React from 'react'

const FourOhFour = () => {
  return (
    <div>
      <h1>
        404: Can't find this page
        <span role="img" aria-label="confused emojie">
          🤷‍♂️
        </span>
      </h1>
    </div>
  )
}

export default FourOhFour
